import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, Message } from 'rsuite'
import { Row, Col, ControlLabel, Input } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import scrollToComponent from 'react-scroll-to-component'
import { useDispatch } from 'react-redux'
import ReportSettingForm from './ReportSettingForm'
import ButtonPanel from '../ButtonPanel'
import ReportSettingView from './ReportSettingView'
import { saveReportSetting } from '../../redux/actions/reportSetting'
import { startLoading, doneLoading } from '../../utils/loading'

export default function ReportSettingWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit, projectCode } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleCallService = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await saveReportSetting(projectCode, request)
      console.log('response', response)
      if (response) {
        setFormSchema(response.forms.reportSetting)
      }
      onChangeIsEdit(!isEdit)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setIsError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setIsError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    handleCallService(data)
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {isEdit && showCommandButton ? (
          <ReportSettingForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        ) : (
          <ReportSettingView schema={formSchema} />
        )}

        {showCommandButton && (
          <>
            <hr />
            <ButtonPanel
              isDisabled={isLoading}
              isEdit={isEdit}
              isError={isError}
              buttonText={formSchema.buttonText || formSchema.header}
              onSave={handleSubmit(onSubmit)}
              onCancel={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
              }}
              onEdit={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
            />
          </>
        )}
      </Panel>
    </>
  )
}
